<div *commonUiOptionalWizardStep id="anteilseignerAngaben">
  <div class="pt-1 mb-1x">
    <div class="d-flex justify-content-between">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.TITEL' | translate }}</h2>
      <common-ui-daten-uebernahme
        (picked)="onAnteilseignerPicked($event)"
        *ngIf="data?.anteilseigner?.length < 99"
        [itemTemplate]="datenuebernahmeAnteilseigner"
        [items]="stammdaten?.unternehmen?.anteilseigner"
        [readonly]="readonly"
        context="Anteilseigner">
      </common-ui-daten-uebernahme>
    </div>
  </div>

  <div *ngIf="data.anteilseigner.length === 0" class="col-sm-12 col-lg-12 p-0">
    <common-ui-card
      [message]=" 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HINWEIS_MINDESTENS_EIN_ANTEILSEIGNER' | translate"
      type="danger">
    </common-ui-card>
  </div>

  <div class="col-sm-12 col-lg-12 p-0 mb-3x">
    <common-ui-card
      [message]=" 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HINWEIS_TREUHANDVERHAELTNISSE' | translate"
      type="info">
    </common-ui-card>
  </div>

  <div class="form-row mb-5x">
    <label
      class="col-sm-8"
      for="treuhand">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.TREUHAND.TITEL' | translate }}
    </label>
    <div class="col-sm-4">
      <select [(ngModel)]="data.treuhand" id="treuhand"  class="form-control"
              (change)="setRequired($event.target['value'])" [disabled]="readonly" [ngClass]="isRequired ? 'required' : ''">
        <option [ngValue]="undefined" *ngIf="isRequired">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.TREUHAND.UNDEFINED' | translate }}</option>
        <option [ngValue]="true" selected>{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.TREUHAND.JA' | translate }}</option>
        <option [ngValue]="false">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.TREUHAND.NEIN' | translate }}
        </option>
      </select>
    </div>
  </div>

  <div class="mb-3x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.SUMME_BETEILIGTER_ANTEILSEIGNER_TITEL' | translate }}</h2>
    <div class="form-row">
      <label class="col-sm-10">
        {{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.SUMME_BETEILIGTER_ANTEILSEIGNER' | translate }}
      </label>
      <div class="col-sm-2">
        <input [(ngModel)]="this.sumOfAnteilseignerPercentage" class="form-control" disabled
               id="sumOfAnteilseignerPercentage">
      </div>
    </div>
  </div>

  <div *ngIf="showMaxLimitHint" class="col-sm-12 col-lg-12 p-0">
    <common-ui-card
      [message]="'COMMON_UI.FRAGEBOGEN.MAX_LIMIT_HINT' | translate"
      type="info">
    </common-ui-card>
  </div>

  <div *ngIf="showAlert" class="col-sm-12 col-lg-12 p-0">
    <common-ui-card
      [message]=" 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HINWEIS_SUMME_DER_BETEILIGUNG_IN_PROZENT_MEHR_ALS_HUNDERT' | translate"
      id="hinweisSummeDerBeteiligungMehrAlsHundert"
      type="danger">
    </common-ui-card>
  </div>

  <div *ngIf="showPercantageAlert" class="col-sm-12 col-lg-12 p-0">
    <common-ui-card
      [message]=" 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HINWEIS_PERCENTAGE_SUM' | translate"
      id="hinweisPercentageSum"
      type="danger">
    </common-ui-card>
  </div>

  <div class="form-row mt-3x">
    <button
      (click)="addAnteilseigner()" *ngIf="!readonly && data?.anteilseigner?.length < 99"
      class="btn btn-light ml-2 mb-2"
      id="addAnteilseigner"
      title="{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.ADD_ANTEILSEIGNER' | translate }}">
      <em class="icon icon-svg icon-fi-hinzufuegen"></em>
      {{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.ADD_ANTEILSEIGNER' | translate }}
    </button>
  </div>

  <div class="mb-5x">
    <ul class="list-group d-flex" id="anteilseignerList">
      <ng-container *ngFor="let anteilseigner of data.anteilseigner; let i = index">
        <li
          (click)="toggleSelect(i)"
          (keypress)="toggleSelect(i)"
          [ngClass]="{'list-group-item-selected': selectedIndex == i}" class="list-group-item common-ui-list-group-item"
          [tabIndex]="0"
          id="anteilseigner{{i}}">
          <div class="d-flex justify-content-between">
            <div
              [innerText]="getDescription(anteilseigner)"
              [ngClass]="{'active': selectedIndex === i }"
              class="h5 list-group-item-heading mb-0 list-item-title text-truncate col-lg-8 col-lg-8-position-static"
              id="anteilseignerDescription{{i}}"></div>
            <div class="d-flex justify-content-between">
              <label class="h5 list-group-item-heading mb-0">Beteiligung in Prozent:</label>
              <label
                [innerText]="getPercentage(anteilseigner)"
                class="h5 list-group-item-heading mb-0 min-width-percentage"
                id="anteilseignerPercentage{{i}}">
              </label>
            </div>
          </div>
          <div class="common-ui-remove-element">
            <button (click)="removeAnteilseigner(i)" *ngIf="!readonly && data?.anteilseigner?.length > 0"
                    class="btn btn-light btn-img"
                    id="removeAnteilseigner{{i}}"
                    title="{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.REMOVE_ANTEILSEIGNER' | translate }}">
              <em class="icon icon-svg icon-fi-loeschen"></em>
            </button>
          </div>
        </li>
        <div
          [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
          class="containing-form">
          <common-ui-anteilseigner-form
            [anteilseignerDetail]="anteilseigner"
            [readonly]="readonly"
            [stammdaten]="stammdaten"
            class="w-100">
          </common-ui-anteilseigner-form>
        </div>
      </ng-container>
    </ul>
  </div>
</div>

<ng-template #datenuebernahmeAnteilseigner let-item="item">
  <div *ngIf="item?.value.natuerlichePerson">
    <h4
      class="list-group-item-heading">{{item?.value.natuerlichePerson.vorname}} {{item?.value.natuerlichePerson.nachname}}</h4>
  </div>
  <div *ngIf="item?.value.juristischePerson">
    <h4 class="list-group-item-heading">{{item?.value.juristischePerson.firmenname}} </h4>
  </div>
</ng-template>
